const BRANDS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
};

/** A card network's name — a proper noun, never translated; an unknown one as sent, capitalized. */
export function brandLabel(brand: string): string {
  const known = BRANDS[brand.toLowerCase()];
  if (known !== undefined) return known;
  return brand.charAt(0).toUpperCase() + brand.slice(1);
}
